/**
 * Maps policy type codes to human-readable labels
 */
export const productTypeLabelMap: { [key: string]: string } = {
  HO3: "Homeowners policy",
  HO4: "Renters policy",
  HO6: "Condo policy",
  HWO: "Wind only policy",
  MHO: "Manufactured home policy",
  DP3: "Dwelling property policy",
  BOP: "Business owner policy",
};

/**
 * Gets the human-readable label for a policy type code
 * @param policyType - The policy type code (e.g., "HO3", "HO6")
 * @returns The human-readable label, or undefined if not found
 */
export const getPolicyTypeLabel = (
  policyType: string | null | undefined,
): string | undefined => {
  if (!policyType) return undefined;
  return productTypeLabelMap[policyType];
};
